import { createSlice } from "@reduxjs/toolkit";

/** Bumps when leave data should refetch (create / update / sign). */
export interface LeaveCalendarState {
  refreshNonce: number;
}

const initialState: LeaveCalendarState = {
  refreshNonce: 0,
};

const leaveCalendarSlice = createSlice({
  name: "leaveCalendar",
  initialState,
  reducers: {
    bumpLeaveCalendarRefresh(state) {
      state.refreshNonce += 1;
    },
  },
});

export const { bumpLeaveCalendarRefresh } = leaveCalendarSlice.actions;
export default leaveCalendarSlice.reducer;
